/** Calendar YMD in Asia/Kolkata for an instant (API string). */
export function formatYmdInTimeZone(date: Date, timeZone: string): string {
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).formatToParts(date);
    const year = parts.find((p) => p.type === 'year')?.value;
    const month = parts.find((p) => p.type === 'month')?.value;
    const day = parts.find((p) => p.type === 'day')?.value;
    return `${year}-${month}-${day}`;
}

export function formatIstYmd(date: Date): string {
    return formatYmdInTimeZone(date, 'Asia/Kolkata');
}

/** Parse YYYY-MM-DD to local Date at midnight (DatePicker value). */
export function parseDateOnly(ymd: string): Date {
    const [year, month, day] = ymd.split('-').map(Number);
    return new Date(year, month - 1, day);
}

export function startOfLocalToday(): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
}

/** Inclusive IST calendar days from→to as YYYY-MM-DD. Walk with setDate, not ms/86400000. */
export function enumerateInclusiveYmd(fromYmd: string, toYmd: string): string[] {
    const days: string[] = [];
    const cursor = parseDateOnly(fromYmd);
    const end = parseDateOnly(toYmd);
    while (cursor.getTime() <= end.getTime()) {
        days.push(formatIstYmd(cursor));
        cursor.setDate(cursor.getDate() + 1);
    }
    return days;
}
